<template>
  <div v-if="isReady" class="main">
    <div class="container">
      <div class="header">
        <div class="logo">
          <img src="@/assets/images/icon_pi_pan_yun.png" />
          <div class="tips">
            <span class="t1">我的派盘管理</span>
            <span class="t2"
              >数据在您手<span style="margin: 0 0.5em">|</span>安全跟您走</span
            >
          </div>
        </div>
        <div class="add-service">
          <a target="_blank" href="https://www.huluer.com/product/fp-pidisk-appc/">
            <el-tooltip effect="dark" content="新建派盘" placement="top">
              <img src="@/assets/images/btn_add_service.png" />
            </el-tooltip>
          </a>
        </div>
      </div>
      <div class="content-warp">
        <div
          v-show="(!isLogin) || (isLogin && isEmptyService())"
          class="title"
          style="border-bottom: 1px solid #999"
        >
          <span>免费试用</span>
        </div>
        <div v-show="isLogin && !isEmptyService()" class="list">
          <div v-for="(item, index) in serviceList" :key="index" class="item">
            <div class="top">
              <div class="top-left">
                <img
                  v-if="item.os == 'windows'"
                  class="system-type"
                  src="@/assets/images/system_windows.png"
                />
                <img
                  v-else-if="item.os == 'darwin'"
                  class="system-type"
                  src="@/assets/images/system_macOS.png"
                />
                <img
                  v-else-if="item.os == 'uos'"
                  class="system-type"
                  src="@/assets/images/system_uos.png"
                />
                <img
                  v-else-if="item.os == 'supered'"
                  class="system-type"
                  src="@/assets/images/system_supered.png"
                />
                <img
                  v-else-if="item.os == 'centos' || item.os == 'ubuntu'"
                  class="system-type"
                  src="@/assets/images/system_linux.png"
                />
                <img
                  v-else
                  class="system-type"
                  src="@/assets/images/system_other.png"
                />
                <img class="line" src="@/assets/images/line.png" />
              </div>
              <div class="top-right">
                <!-- 开关按钮 -->
                <el-tooltip
                  v-if="isWaiting(item.id)"
                  effect="dark"
                  content="请等待"
                  placement="top"
                >
                  <img
                    src="@/assets/images/icon_waiting.gif"
                    class="icon action"
                  />
                </el-tooltip>
                <el-tooltip
                  v-else-if="item.started === 0"
                  effect="dark"
                  content="启动服务"
                  placement="top"
                >
                  <img
                    src="@/assets/images/icon_first.png"
                    class="icon action"
                    @click="startService(item.id)"
                  />
                </el-tooltip>
                <el-tooltip
                  v-else-if="item.started === 1"
                  effect="dark"
                  content="启动服务"
                  placement="top"
                >
                  <img
                    src="@/assets/images/icon_stop.png"
                    class="icon action"
                    @click="resumeService(item.id)"
                  />
                </el-tooltip>
                <el-tooltip
                  v-else-if="item.started === 2"
                  effect="dark"
                  content="暂停服务"
                  placement="top"
                >
                  <img
                    src="@/assets/images/icon_off.png"
                    class="icon action"
                    @click="pauseService(item.id)"
                  />
                </el-tooltip>
                <el-tooltip
                  v-else-if="item.started === 3"
                  effect="dark"
                  content="暂停服务"
                  placement="top"
                >
                  <img
                    src="@/assets/images/icon_on.png"
                    class="icon action"
                    @click="pauseService(item.id)"
                  />
                </el-tooltip>
              </div>
            </div>
            <div class="top2">
              <div class="service-name">
                <!-- 编辑/保存按钮 -->
                <el-tooltip
                  v-if="item.id !== editId"
                  effect="dark"
                  content="编辑"
                  placement="top"
                >
                  <img
                    @click="edit(item.id)"
                    src="@/assets/images/icon_setting.png"
                    class="icon action"
                  />
                </el-tooltip>
                <el-tooltip v-else effect="dark" content="保存" placement="top">
                  <img
                    src="@/assets/images/icon_save.png"
                    class="icon action"
                    @click="save(item)"
                  />
                </el-tooltip>
                <span>别名：</span>
                <input
                  v-if="item.id === editId"
                  type="text"
                  v-model="item.name"
                  @blur="save(item)"
                />
                <span class="value" v-else>{{ item.name }}</span>
              </div>
              <div class="due-day">
                <!-- 续费 -->
                <el-tooltip effect="dark" content="续费" placement="top">
                  <img
                    @click="renew(item)"
                    src="@/assets/images/icon_renew.png"
                    class="icon action"
                  />
                </el-tooltip>
                <span>时效：</span>
                <span
                  class="value"
                  :style="{
                    color:
                      item.expired_at - new Date() / 1000 < 15 * 60 * 60 * 24
                        ? '#f21717'
                        : ''
                  }"
                >
                  <template v-if="item.expired_at - new Date() / 1000 > 0"
                    >{{ item.expired_at | formatDueDay }}天</template
                  >
                  <template v-else>服务过期</template>
                </span>
              </div>
              <div class="service-link">
                <a
                  class="icon action"
                  target="_blank"
                  :href="getUrl(item.subdomain)"
                >
                  <img
                    src="@/assets/images/icon_link.png"
                    class="icon action"
                  />
                </a>
                <span>地址：</span>
                <span class="value">{{
                  getUrl(item.subdomain, "", true)
                }}</span>
              </div>
            </div>
            <div v-show="item.started != 0" class="w">
              <div class="context">
                <div class="service-type">
                  <a target="_blank" :href="getUrl(item.subdomain)">
                    <img src="@/assets/images/icon_pan.png" alt="" />
                  </a>
                </div>
                <div class="service-type">
                  <a
                    target="_blank"
                    v-if="
                      [4, 7].some(n => {
                        return n === item.service_type_id;
                      }) ||
                        (item.service_type_id === 6 && item.user_data.syncthing)
                    "
                    :href="getUrl(item.subdomain, 'backup')"
                  >
                    <img src="@/assets/images/icon_backup.png" alt="" />
                  </a>
                  <a v-else href="javascript:;" class="no-action">
                    <img src="@/assets/images/icon_backup2.png" alt="" />
                  </a>
                  <!-- <span>数据镜像</span> -->
                </div>
                <div class="service-type">
                  <a
                    target="_blank"
                    v-if="
                      [2, 3, 4, 7].some(n => {
                        return n === item.service_type_id;
                      }) ||
                        (item.service_type_id === 6 && item.user_data.webdav)
                    "
                    :href="getUrl(item.subdomain, 'webdav')"
                  >
                    <img src="@/assets/images/icon_webdav.png" alt="" />
                  </a>
                  <a v-else href="javascript:;" class="no-action">
                    <img src="@/assets/images/icon_webdav2.png" alt="" />
                  </a>
                  <!-- <span>WebDAV</span> -->
                </div>
                <div class="service-type">
                  <a
                    target="_blank"
                    v-if="
                      [3, 4, 7].some(n => {
                        return n === item.service_type_id;
                      }) ||
                        (item.service_type_id === 6 && item.user_data.dongle)
                    "
                    :href="getUrl(item.subdomain, 'dongle')"
                  >
                    <img src="@/assets/images/icon_dongle.png" alt="" />
                  </a>
                  <a v-else href="javascript:;" class="no-action">
                    <img src="@/assets/images/icon_dongle2.png" alt="" />
                  </a>
                  <!-- <span>加密套件</span> -->
                </div>
              </div>
            </div>
            <div v-show="item.started == 0" class="no-active">
              <img
                v-if="isWaiting(item.id)"
                src="@/assets/images/btn_on_pan.png"
                alt=""
                class="btn btn-disable"
              />
              <img
                v-else
                @click="startService(item.id)"
                src="@/assets/images/btn_on_pan.png"
                alt=""
                class="btn action"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-show="(!isLogin) || (isLogin && isEmptyService())" class="add-trial">
        <div>
          <span
            style="margin-left: 1em;"
            >亲爱的用户：</span
          >
        </div>
        <div>
          <span
            style="margin-left: 2.2em;"
            >您当前没有任何服务，敬请登录账号后添加试用。</span
          >
        </div>
        <div class="gif">
          <img @click="addTrial()" src="@/assets/images/trial.gif">
        </div>
        <div class="btn-div">
          <img
            class="btn"
            :style="{opacity: trialBtnIsLoading ? 0.6 : 1, cursor: trialBtnIsLoading ? 'default': 'pointer'}"
            @click="addTrial()"
            src="@/assets/images/btn_add_trial.png"
            alt=""
          />
        </div>
        <div class="nav">
          <a target="_blank" href="https://www.huluer.com/6679/">试用帮助</a>
          <a target="_blank" href="https://demo.huluer.vip">演示入口</a>
        </div>
        <div class="tips">
          <span>注：领取试用问题请点击<a target="_blank" href="https://www.huluer.com/6679/">试用帮助</a>；或询问在线客服（网站右下角）。</span>
        </div>
      </div>
      <div class="footer">
        <div>
          <img class="fish" src="@/assets/images/gray_fish.png" />
          <img class="fish" src="@/assets/images/blue_fish.png" />
          <img class="fish" src="@/assets/images/gray_fish.png" />
        </div>
      </div>
    </div>
  </div>
  <div v-else class="loading-box">
    <img class="loading-img" src="@/assets/images/loading.gif" >
  </div>
</template>

<script>
import * as api from '@/utils/api.js'
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'ServiceList3',
  data () {
    return {
      serviceList: null,
      waitingIds: [],
      editId: -1,
      timer: null,
      renewDialogVisible: false,
      renewData: {
        urlM: '',
        urlY: '',
        name: 'xxxx'
      },
      isReady: false,
      trialBtnIsLoading: false
    }
  },
  computed: {
    ...mapState(['user']),
    ...mapGetters(['isLogin', 'isPC'])
  },
  async created () {
    this.$store.dispatch('init')
  },
  mounted () {
    this.getServiceList().finally(() => {
      this.isReady = true
    })
    if (this.timer) {
      clearInterval(this.timer)
    } else {
      this.timer = setInterval(async () => {
        await this.getServiceList()
        console.log(this.serviceList)
      }, 1000 * 20)
    }
  },
  destroyed () {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    isOneNoStartedService () {
      return (
        this.serviceList &&
        this.serviceList.length === 1 &&
        this.serviceList[0].user_id > 0 &&
        this.serviceList[0].started === 0
      )
    },
    isEmptyService () {
      return (
        !this.serviceList ||
        this.serviceList.length === 0 ||
        this.serviceList[0].user_id === 0
      )
    },
    getUrl (subdomain, type, noPrefix) {
      let url = `https://${subdomain}.huluer.vip`
      if (noPrefix) {
        url = `${subdomain}.huluer.vip`
      }
      switch (type) {
        case 'webdav':
          url += '/dataSync'
          break
        case 'dongle':
          url += '/dongle'
          break
        case 'backup':
          url += '/backup'
          break
        default:
          break
      }
      return url
    },
    async getServiceList () {
      this.serviceList = await api.getServiceList(this.user.id, this.user.jwt)
    },
    async addTrial () {
      if (this.trialBtnIsLoading) {
        return
      }
      this.trialBtnIsLoading = true
      if (!this.isLogin) {
        window.parent.location.href = 'https://www.huluer.com/login/?redirect_to=https%3A%2F%2Fwww.huluer.com'
        return
      }
      try {
        await api.addTrial(this.user.id, this.user.jwt)
        await this.getServiceList()
      } catch (error) {
        console.log(error)
      }
      this.trialBtnIsLoading = false
    },
    async pauseService (serviceId) {
      if (!this.isLogin) {
        alert('请先登录再进行操作！')
        return
      }
      // 添加到等待列表
      this.waitingIds.push(serviceId)
      try {
        await api.pauseService(this.user.id, this.user.jwt, serviceId)
        await this.getServiceList()
      } catch (error) {
        console.log(error)
      }
      // 从等待列表移除
      const index = this.waitingIds.indexOf(serviceId)
      if (index >= 0) this.waitingIds.splice(index, 1)
    },
    async resumeService (serviceId) {
      if (!this.isLogin) {
        alert('请先登录再进行操作！')
        return
      }
      // 添加到等待列表
      this.waitingIds.push(serviceId)
      try {
        await api.resumeService(this.user.id, this.user.jwt, serviceId)
        await this.getServiceList()
      } catch (error) {
        console.log(error)
      }
      // 从等待列表移除
      const index = this.waitingIds.indexOf(serviceId)
      if (index >= 0) this.waitingIds.splice(index, 1)
    },
    async startService (serviceId) {
      if (!this.isPC) {
        alert('请在PC电脑上进行操作!')
        return
      }
      if (!this.isLogin) {
        alert('请先登录再进行操作！')
        return
      }
      const r = confirm(
        '请确认（1）这是您的个人电脑；（2）本次服务在此电脑部署云化环境并生成远程文件夹。'
      )
      if (r === false) return
      // 添加到等待列表
      this.waitingIds.push(serviceId)
      try {
        await api.startService(this.user.id, this.user.jwt, serviceId)
        await this.getServiceList()
      } catch (error) {
        console.log(error)
      }
      // 从等待列表移除
      const index = this.waitingIds.indexOf(serviceId)
      if (index >= 0) this.waitingIds.splice(index, 1)
    },
    isWaiting (serviceId) {
      return this.waitingIds.some(id => {
        return id === serviceId
      })
    },
    edit (serviceId) {
      if (!this.isLogin) {
        alert('请先登录再进行操作！')
        return
      }
      this.editId = serviceId
    },
    async save (item) {
      if (!this.isLogin) {
        alert('请先登录再进行操作！')
        return
      }
      if (!item.name) {
        alert('服务名不能为空')
        return
      }
      await api.updateServiceName(
        this.user.id,
        this.user.jwt,
        item.id,
        item.name
      )
      this.editId = -1
    },
    renew (item) {
      // alert('攻城狮正在开发！敬请期待！')
      if (!this.isLogin) {
        alert('请先登录再进行操作！')
        return
      }
      const existsWebDAV = item.sub_services.some(
        v => v.service_type_id === 8
      )
      const existsCipherSuite = item.sub_services.some(
        v => v.service_type_id === 9
      )
      let url = `https://www.huluer.com/product/renew-basic/?service-id=${item.id}`
      if (existsCipherSuite) {
        url = `https://www.huluer.com/product/renew-elite/?service-id=${item.id}`
      } else if (existsWebDAV) {
        url = `https://www.huluer.com/product/renew-geek/?service-id=${item.id}`
      }
      window.parent.location.href = url
    }
  },
  filters: {
    dateFormat: function (value) {
      const d = new Date(value * 1000)
      const Y = d.getFullYear()
      let M = d.getMonth() + 1
      if (M < 10) {
        M = `0${M}`
      }
      let D = d.getDate()
      if (D < 10) {
        D = `0${D}`
      }
      return `${Y}.${M}.${D}`
    },
    formatDueDay: function (val) {
      return Math.round((val - new Date() / 1000) / 60 / 60 / 24)
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
a {
  text-decoration: none;
  color: #666;
}
.action {
  cursor: pointer;
}
.no-action {
  cursor: default;
}
.btn-disable {
  opacity: 0.5;
  cursor: default;
}
.loading-box{
  width: 640px;
  height: 590px;
  border: 2px solid rgba(255, 255, 255, 0);
  margin: 0 auto;
  font-size: 16px;
  position: relative;
  .loading-img {
    width: 8em;
    height: 8em;
    position: absolute;
    left: 50%;
    top:50%;
    transform:translate(-50%,-50%);
  }
}
.main {
  font-size: 16px;
  width: 640px;
  height: 590px;
  background: url(./../assets/images/bg.png) no-repeat;
  border: 2px solid rgba(255, 255, 255, 0);
  margin: 0 auto;
  position: relative;
  .container {
    width: 540px;
    margin: 0 auto;
    font-size: 16px;
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 2em;
      .add-service {
        display: flex;
        align-items: center;
        img {
          height: 4em;
          margin-right: 1em;
          outline: none;
        }
        span {
          font-size: 1.5em;
        }
      }
      .logo {
        height: 6em;
        display: flex;
        align-items: center;
        img {
          height: 5.5em;
          margin-right: 1em;
        }
        .tips {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          span {
            padding: 0.25px;
            color: #777;
          }
          .t1 {
            font-size: 2em;
            margin-bottom: 0.3em;
          }
          .t2 {
            font-size: 0.875em;
            white-space: nowrap;
          }
        }
      }
    }
    .content-warp {
      margin-top: 0.5em;
      max-height: 420px;
      overflow-x: hidden;
      overflow-y: scroll;
      scrollbar-color: transparent transparent;
      scrollbar-track-color: transparent;
      -ms-scrollbar-track-color: transparent;
      .title {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 1.357em;
        letter-spacing: 0.5em;
        padding-left: 0.5em;
        padding-bottom: 0.4em;
        color: #3495ee;
        font-size: 1.625em;
        .new-buy {
          font-size: 1.3em;
          line-height: 1.3em;
          padding: 0.1em 0.5em 0.2em 0.5em;
          border: none;
          color: #fff;
          border-radius: 5px;
          background-color: #3495ee;
          outline: none;
        }
      }
      .list {
        color: #666;
        .item {
          margin-bottom: 1em;
          .top {
            display: flex;
            justify-content: space-between;
            margin-bottom: 5px;
            .top-left {
              display: flex;
              align-items: center;
              overflow: hidden;
              width: 450px;
              height: 30px;
              .system-type {
                display: flex;
                align-items: center;
                padding-right: 1em;
                height: 30px;
              }
              .line {
                height: 1px;
                width: 24em;
              }
              span {
                white-space: nowrap;
              }
              input {
                border: none;
                background: rgba(52, 149, 238, 0.27);
                border-radius: 4px;
                font-size: 1em;
              }
            }
            .top-right {
              display: flex;
              align-items: center;
              justify-content: space-between;
              .icon {
                width: 30px;
                height: 30px;
              }
              .icon:first-child {
                margin-right: 20px;
              }
              .icon:last-child {
                margin-right: 30px;
              }
            }
          }
          .top2 {
            display: flex;
            justify-content: space-between;
            height: 1.5em;
            font-size: 0.75em;
            margin: 1em;
            .icon {
              width: 25px;
              height: 25px;
            }
            .service-name,
            .due-day,
            .service-link {
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .service-name {
              .value {
                width: 8em;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              input {
                font-size: 1em;
                width: 8em;
              }
            }
            .due-day {
              .value {
                width: 4em;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            .service-link {
              .value {
                width: 9em;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
          .w {
            padding: 20px 60px;
            height: 7em;
          }
          .context {
            display: flex;
            justify-content: space-between;
            .service-type {
              font-size: 0.875em;
              display: flex;
              flex-direction: column;
              align-items: center;
              img {
                height: 5em;
              }
            }
          }
          .bottom {
            margin-top: 1em;
            text-align: right;
            a {
              color: #3495ee;
              margin-left: 1em;
            }
          }
        }
      }
      &::-webkit-scrollbar {
        display: none;
        width: 5px;
        height: 5px;
      }
      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        border-radius: 10px;
        width: 10px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 2px;
        background: #bbb;
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
      }
      &::-webkit-scrollbar-thumb:window-inactive {
        background: #eee;
      }
    }
    .renew-dialog {
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.3);
      border-radius: 5px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      .dialog-main {
        padding: 10px 15px;
        width: 20em;
        height: 10em;
        border-radius: 5px;
        background-color: #fff;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        .dialog-header {
          display: flex;
          justify-content: space-between;
          margin-bottom: 1em;
        }
        .dialog-context {
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .dialog-bottom {
          display: flex;
          justify-content: space-around;
          padding: 20px;
          .button {
            font-size: 1em;
            line-height: 1em;
            padding: 0.1em 0.5em 0.2em 0.5em;
            border: none;
            color: #fff;
            border-radius: 5px;
            background-color: #3495ee;
            outline: none;
          }
        }
      }
    }
    .no-login {
      text-align: right;
      font-weight: bold;
      padding: 1em;
      a {
        color: #3495ee;
      }
    }
    .add-trial {
      font-size: 1.25em;
      margin-top: 1em;
      color: #777;
      & > div {
        height: 2em;
        display: flex;
        align-items: center;
      }
      .btn {
        height: 2em;
        cursor: pointer;
      }
      .gif {
        height: 5em;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          height: 5em;
        }
      }
      .btn-div {
        font-size: 0.8em;
        height: 4em;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .nav {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 4em;
        a {
          color: #3495ee;
          border-bottom: 1px solid #3495ee;
        }
      }
      .tips {
        font-size: 0.8em;
        margin-top: 1em;
        a {
          color: #3495ee;
        }
      }
    }
    .no-active {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 7em;
      img {
        height: 2em;
      }
    }
    .footer {
      position: absolute;
      bottom: 5px;
      left: 50%;
      transform: translateX(-50%);
      .fish {
        height: 10px;
        width: 24px;
        margin: 0 10px;
      }
    }
  }
}
@media screen and (max-width: 450px) {
  .loading-box {
    width: 320px !important;
    height: 450px !important;
    font-size: 12px;
  }
  .main {
    width: 320px !important;
    height: 450px !important;
    .container {
      width: 300px !important;
      font-size: 12px;
      .header {
        .logo {
          img {
            height: 3.5em;
          }
          .tips {
            .t1 {
              font-size: 1.5em;
            }
          }
        }
      }
      .top-left {
        width: 210px !important;
      }
      .content-warp {
        max-height: 320px !important;
        .list .item .w {
          padding: 1em 1em;
          .context .service-type img {
            height: 7em;
          }
        }
        .list .item .top .line {
          width: 16em !important;
        }
        .list .item .top2 {
          height: 5.5em;
          flex-direction: column;
          align-items: start;
          font-size: 14px;
          .service-name .value {
            width: 14em;
          }
          .due-day .value {
            width: 14em;
          }
          .service-link .value {
            width: 14em;
          }
        }
      }
      .footer .fish {
        margin: 0 5px;
      }
    }
  }
}
</style>
